import React, { Component, Fragment } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';

import Buttonlet from 'components/Buttonlet';

import { deleteEntry, fetchSharedContent } from 'actions/profile';

import DeleteDialog from './DeleteDialog';

class JournalEntry extends Component {
  mounted = false

  state = { modalIsOpen: false }

  componentDidMount = () => {
    this.mounted = true;
  }

  componentWillUnmount = () => {
    this.mounted = false;
  }

  deleteAndClose = async () => {
    const { canEdit, data, dispatch } = this.props;
    // What are we doing here if we can't edit this profile? Never mind;
    // just return
    if (!canEdit) {
      return;
    }
    await dispatch(deleteEntry(data.id));
    if (this.mounted) {
      this.handleRequestClose();
    }
  }

  handleFetchFromId = () => {
    const {
      dispatch,
      profileCharacter: { name },
      data: { id },
    } = this.props;
    dispatch(fetchSharedContent({ characterName: name, fromId: id }));
  }

  handleRequestClose = () => {
    this.setState({ modalIsOpen: false });
  }

  showModal = () => {
    this.setState({ modalIsOpen: true });
  }

  /**
   * Render
   * @return {Object}
   */
  render() {
    const {
      data,
      canEdit,
      isFetching,
      profileCharacter,
    } = this.props;
    const { modalIsOpen } = this.state;

    if (!profileCharacter) {
      return null;
    }

    const { name } = profileCharacter;
    const {
      areaName,
      fallenLondonDateTime,
      id,
    } = data;

    return (
      <Fragment>
        <div
          className={classnames('journal-entry', isFetching && 'journal-entry--is-fetching')}
          style={{ marginBottom: 16 }}
        >
          <div className="media__body">
            <div className="journal-entry__buttonlet">
              {canEdit && (
                <Buttonlet
                  type="delete"
                  title="Delete this plan"
                  onClick={this.showModal}
                />
              )}
            </div>
            <h4
              className="heading heading--2 heading--inverse journal-entry__title"
              dangerouslySetInnerHTML={{ __html: data.eventName }}
            />
            <h2 className="media__heading heading heading--3 journal-entry__date-and-location">
              <span className="journal-entry__date">
                {fallenLondonDateTime}
                {' '}
              </span>
              <span className="journal-entry__location">
                {areaName && `(${areaName})`}
                <Link
                  className="link--inverse journal-entry__permalink"
                  to={`/profile/${name}/${id}`}
                  onClick={this.handleFetchFromId}
                >
                  <i className="fa fa-link" />
                </Link>
              </span>
            </h2>
            <div
              className="journal-entry__body"
              dangerouslySetInnerHTML={{ __html: data.playerMessage }}
            />
          </div>
        </div>
        <DeleteDialog
          isOpen={modalIsOpen}
          isFetching={isFetching}
          onConfirm={this.deleteAndClose}
          onRequestClose={this.handleRequestClose}
        />
      </Fragment>
    );
  }
}

JournalEntry.displayName = 'JournalEntry';

JournalEntry.propTypes = {
  canEdit: PropTypes.bool.isRequired,
  dispatch: PropTypes.func.isRequired,
  data: PropTypes.shape({}).isRequired,
  isFetching: PropTypes.bool.isRequired,
  profileCharacter: PropTypes.shape({}),
};

JournalEntry.defaultProps = {
  profileCharacter: undefined,
};

const mapStateToProps = ({ profile }) => ({
  canEdit: profile.isLoggedInUsersProfile,
  profileCharacter: profile.profileCharacter,
});

export default withRouter(connect(mapStateToProps)(JournalEntry));